import './abstract_section_view.coffee'
Namespace('Monitoring.Reports.Executive')

class Monitoring.Reports.Executive.SocialNetworksView extends Monitoring.Reports.Executive.AbstractSectionView
  id: 'social'
  tagName: 'section'
  template: JST["backbone/templates/monitoring/reports/executive/social_networks"]
  legendsTemplate: JST["backbone/templates/monitoring/reports/executive/hierarchy_legends"]

  initialize: (@options = {}) ->
    @users = null
    @title = "Users"

  render: ->
    brand = @options.settings.accountLabel.description
    @bindChartsReady(2)

    @$el.html(@template(brand: brand, title: @title))
    @addInfluencersData("#"+@id+" #users-data")
    @addHashtagsData("#"+@id+" #hashtags-data")
    return this

  addInfluencersData: (divId)->
    query = @extendedQuery({
      dimension: 'user'
      labels: @options.settings.accountLabel.codes
      type: ['twitter']
    })
    query.users = @users if @users
    $.post(@options.chartApi.singleDimension, query, (response) =>
      usuarios = _.sortBy(response.series[0].data, (point) -> -point.y).slice(0,9)
      $.each usuarios, (index, usuario) =>
        $(divId).append("<p class=\"sentiment ord-#{index}\"><span class=\"num\">#{usuario.y}</span> <img referrerpolicy='#{window.referrer_policy_for("https://twitter.com/#{usuario.code}/profile_image?size=normal")}' style='vertical-align: top; height: 34px;' src='https://twitter.com/#{usuario.code}/profile_image?size=normal'> <span class=\"nom\">#{usuario.name}</span></p>")
      @chartReady()
    )

  addHashtagsData: (divId) ->
    query = @extendedQuery({
      dimension: 'hashtags'
      labels: @options.settings.accountLabel.codes
    })
    query.users = @users if @users
    $.post(@options.chartApi.singleDimension, query, (response) =>
      @_removeMissing(response)
      hashtags = _.sortBy(response.series[0].data, (point) -> -point.y).slice(0,9)
      $.each hashtags, (index, hashtag) =>
        $(divId).append("<p class=\"sentiment ord-#{index}\"><span class=\"num\">#{hashtag.y}</span> <span class=\"nom\">#{hashtag.name}</span></p>")
      @chartReady()
    )
